import type React from 'react';
import { Alert, AlertTitle, Box } from '@mui/material';
import type { VideoHealthWarning, VideoServiceHealth } from '../types';

const WARNING_TEXT: Record<VideoHealthWarning, string> = {
  capability_inactive: 'capability is inactive',
  no_active_model: 'no active model is mapped (Capability → Models)',
  no_priced_model:
    'no mapped model has a video price (LLM Catalog → Unit Pricing: video_second or video)',
};

interface VideoHealthAlertsProps {
  health: VideoServiceHealth | undefined;
  /** Only report these capabilities (e.g. the ones assigned to a package). */
  capabilityCodes?: string[];
}

/** Warns when a Generate Video operation cannot run for users (spec §9). */
export const VideoHealthAlerts: React.FC<VideoHealthAlertsProps> = ({
  health,
  capabilityCodes,
}) => {
  const problems = (health?.operations ?? []).filter(
    (operation) =>
      operation.warnings.length > 0 &&
      (!capabilityCodes || capabilityCodes.includes(operation.capabilityCode))
  );
  if (problems.length === 0) return null;

  return (
    <Alert severity="warning">
      <AlertTitle>Generate Video is not fully configured</AlertTitle>
      <Box component="ul" className="m-0 list-disc pl-5">
        {problems.map((operation) => (
          <li key={operation.capabilityCode}>
            <span className="font-mono">{operation.capabilityCode}</span>:{' '}
            {operation.warnings.map((warning) => WARNING_TEXT[warning]).join('; ')}
          </li>
        ))}
      </Box>
    </Alert>
  );
};
